import { useEffect, useState } from "react";
import axios from "../../API/axios";
import Linkify from "linkify-react";
import moment from "moment";
import { Link } from "react-router-dom";
import SinglePostInteraction from "./SinglePostInteraction";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";

const PostComponent = ({ item }) => {
  const guestModeData = localStorage.getItem("guestMode");
  const [postContentMap, setPostContentMap] = useState({});
  const [userData, setUserData] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const [errorImage, setErrorImage] = useState(false);
  const uid = item?.postInfo?.sharedPost?.postOriginId;
  const [imageArray, setImageArray] = useState([]);
  const [initialSlideIndex, setInitialSlideIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [sharedPostContent, setSharedPostContent] = useState({});

  const openModal = (images) => {
    // console.log('clicke');
    setModalImages(images);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  console.log("postcontent", item);
  const readMore = async (id) => {
    try {
      const res = await axios.get(
        `/Posts/GetPostMainContent/?DeviceType=Web&PostId=${id}`
      );
      setPostContentMap((prevMap) => ({
        ...prevMap,
        [id]: res.data.responseData,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  //   const getUserProfile = () => {
  //     setIsloading(true);
  //     const data = {
  //       deviceType: "Web",
  //       userUid: uid,
  //     };
  //     axios
  //       .post(`UserProfile/GetUserProfile`, data)
  //       .then((response) => {
  //         console.log("responseData", response);
  //         if (response.status === 204) {
  //           setErrorImage(true);
  //         } else {
  //           const res = response.data.responseData;
  //           setUserData(res);
  //           setIsloading(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setIsloading(false);
  //       });
  //   };
  //   useEffect(() => {
  //     getUserProfile();
  //   }, [uid]);

  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const anchors = div.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML;
  };

  const linkifyContent = (htmlContent) => {
    const urlPattern =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  const replaceDynamicValues = (content, dynamicValues) => {
    if (!content || !dynamicValues) return content;

    dynamicValues.forEach((item) => {
      const placeholder = `{${item?.dVno}}`;
      const replacement =
        item?.type === "UserMention"
          ? `<a href="/user/${item?.entityID}" class="user-mention">@${item?.displayName}</a>`
          : item?.type === "Hashtag"
          ? `<a href="/hashtag/${item?.displayName}" class="hashtag">#${item?.displayName}</a>`
          : item?.displayName;

      content = content.replaceAll(placeholder, replacement);
    });

    return content;
  };

  const formattedContent = linkifyContent(
    addTargetBlankToAnchors(
      replaceDynamicValues(
        item?.postInfo?.postContent,
        item?.postInfo?.dynamicValues
      )
    )
  );

  const sharedPostFormattedContent = linkifyContent(
    addTargetBlankToAnchors(
      replaceDynamicValues(
        item?.postInfo?.sharedPost?.postContent,
        item?.postInfo?.sharedPost?.dynamicValues
      )
    )
  );

  console.log("consoling item", item);
  return (
    <>
      <div>
        <Link
          to={
            item?.cntntTypCategory === "Article"
              ? `/Article/${item?.postInfo?.articleInfo?.titleSlug}`
              : undefined
          }
        >
          {item?.postInfo?.postContent && (
            <div className="f-14 p-2 postContent">
              <div
                className="postContentDiv"
                dangerouslySetInnerHTML={{
                  __html: formattedContent,
                }}
              />

              {!postContentMap[item?.postInfo?.postId] &&
                item?.postInfo?.readMore && (
                  <a onClick={() => readMore(item?.postId)} className="pointer">
                    Read More
                  </a>
                )}
            </div>
          )}
        </Link>
        {item?.postInfo?.sharedPost ? (
          <>
            <div className="row w-94 m-0 singlePostLink">
              <div className="featured-card user-postOnlyContent">
                <div className="feature-content p-2 d-flex justify-content-between">
                  {item?.postInfo?.sharedPost?.postOriginType === "Company" ? (
                    <Link
                      to={`/Company/${item?.postInfo?.sharedPost?.userUid}`}
                    >
                      <div className="d-flex align-items-center">
                        <div className="ImgAvatar">
                          <img
                            src={item?.postInfo?.sharedPost?.userAvatar}
                            alt=""
                            style={{ borderRadius: "50px" }}
                          />
                        </div>
                        <div className="ms-2">
                          <h4 className="f-14 fw-bold mb-0">
                            {item?.postInfo?.sharedPost?.userName}
                          </h4>
                          <p className="f-12">
                            {/* {moment(item?.sharedPost.creationTime).format(
                               "MMMM Do YYYY, h:mm:ss a"
                             )} */}
                            {moment
                              .utc(item?.postInfo?.sharedPost?.creationTime)
                              .local()
                              .format("DD MMMM YYYY [at] h:mm a")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  ) : (
                    <Link to={`/User/${item?.postInfo?.sharedPost?.userUid}`}>
                      <div className="d-flex align-items-center">
                        <div className="ImgAvatar">
                          <img
                            src={item?.postInfo?.sharedPost?.userAvatar}
                            alt=""
                            style={{ borderRadius: "50px" }}
                          />
                        </div>
                        <div className="ms-2">
                          <h4 className="f-14 fw-bold mb-0">
                            {item?.postInfo?.sharedPost?.userName}
                          </h4>
                          <p className="f-12">
                            {/* {moment(item?.sharedPost.creationTime).format(
                               "MMMM Do YYYY, h:mm:ss a"
                             )} */}
                            {moment
                              .utc(item?.postInfo?.sharedPost?.creationTime)
                              .local()
                              .format("DD MMMM YYYY [at] h:mm a")}
                          </p>
                        </div>
                      </div>
                    </Link>
                  )}

                  {guestModeData === "true" ? null : (
                    <div className="row">
                      <div>
                        <SinglePostInteraction
                          postId={item?.postInfo?.sharedPost?.postId}
                          // AllPostList={AllPostList}
                          // ite.sharedPost={item?.sharedPost}
                          // setitem?.sharedPost={setitem?.sharedPost}
                          // isfollowed={isfollowed}
                          // setIsfollowed={setIsfollowed}
                        />
                      </div>
                    </div>
                  )}
                </div>
                {item?.postInfo?.sharedPost?.postContent && (
                  <>
                    <div className="f-14 p-2 postContent">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sharedPostFormattedContent,
                        }}
                      />
                    </div>
                    <div
                      className="feed-post"
                      style={{
                        paddingTop:
                          item?.postInfo?.sharedPost?.postMediaCount === 0
                            ? "60px"
                            : "4px",
                      }}
                    >
                      <div className="row">
                        {item?.postInfo?.sharedPost?.mediaFilesList
                          ?.slice(0, 4)
                          ?.map((file, idx) => (
                            <div
                              key={idx}
                              className={`col-${
                                item?.postInfo?.sharedPost?.mediaFilesList
                                  .length === 1
                                  ? "12"
                                  : "6"
                              } ${
                                item?.postInfo?.sharedPost?.mediaFilesList
                                  .length === 3 && idx === 0
                                  ? "col-12"
                                  : ""
                              }`}
                              style={{
                                position: "relative",
                                padding:
                                  item?.postInfo?.sharedPost?.mediaFilesList
                                    .length === 1
                                    ? "0"
                                    : item?.postInfo?.sharedPost?.mediaFilesList
                                        .length === 3 && idx === 0
                                    ? "0 0 5px 0"
                                    : item?.postInfo?.sharedPost?.mediaFilesList
                                        .length === 3 && idx === 1
                                    ? "0 5px 5px 0"
                                    : item?.postInfo?.sharedPost?.mediaFilesList
                                        .length === 4 && idx === 2
                                    ? "0 5px 0 0"
                                    : item?.postInfo?.sharedPost?.mediaFilesList
                                        .length === 4 && idx === 0
                                    ? "0 5px 5px 0"
                                    : item?.postInfo?.sharedPost?.mediaFilesList
                                        .length === 2 && idx === 0
                                    ? "0 5px 5px 0"
                                    : "0",
                              }}
                            >
                              <h2>{file.length}</h2>
                              <img
                                src={file.mediaName}
                                alt=""
                                className="img-fluid"
                                width={"100%"}
                              />
                              {idx === 3 &&
                                item?.postInfo?.sharedPost?.postMediaCount >
                                  4 && (
                                  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                    +
                                    {item?.postInfo?.sharedPost
                                      ?.postMediaCount - 4}
                                  </div>
                                )}
                            </div>
                          ))}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            {/* </div> */}
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default PostComponent;
